import { render } from "./matching-list-interests-user.vue?vue&type=template&id=af024730&scoped=true&ts=true"
import script from "./matching-list-interests-user.vue?vue&type=script&lang=ts"
export * from "./matching-list-interests-user.vue?vue&type=script&lang=ts"

import "./matching-list-interests-user.vue?vue&type=style&index=0&id=af024730&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af024730"]])

export default __exports__